import Styles from './NSBarTitle.module.css';
import { StringFormatter } from '../main';

export interface NSBarTitleProps 
{
	title: string;
	description?: string;
}

export function NSBarTitle(props: NSBarTitleProps)
{
	return (
		<div className="container">
			<h1 className={Styles.title}>{props.title}</h1>
			{
				props.description &&
				<p className={Styles.description}>{
					StringFormatter.toHTML(props.description)
				}
				</p>
			}
		</div>
	);
}